import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/company-ticket/'

export const get = async (obj) => {
  let _params = { ... obj.data }
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${obj.companyId}`,
    params: _params
  })
  return response?.data
}

